import { render, staticRenderFns } from "./setTemplate.vue?vue&type=template&id=7b803e37&scoped=true&"
import script from "./setTemplate.vue?vue&type=script&lang=js&"
export * from "./setTemplate.vue?vue&type=script&lang=js&"
import style0 from "./setTemplate.vue?vue&type=style&index=0&id=7b803e37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b803e37",
  null
  
)

export default component.exports